import { Controller, FieldValues, RegisterOptions, useFormContext } from "@graphcommerce/ecommerce-ui";
import { InputHTMLAttributes, useEffect } from "react";

type SimpleTextInputProps = {
  name: string;
  label?: string,
  height?: string,
  rules?: Omit<RegisterOptions<FieldValues, string>, "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled">
} & InputHTMLAttributes<HTMLInputElement>
export default function SimpleTextInput({ name, label, required, rules, defaultValue, height }: SimpleTextInputProps) {
  const { control, formState: { errors }, setValue } = useFormContext();

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue)
    }
  }, [defaultValue])
  return (
    <div className="w-full">
      <Controller
        name={name}
        control={control}
        rules={{
          ...rules,
          ...(required ? { required: `واردکردن موارد ستاره‌دار الزامی است.` } : null)
        }}
        render={({ field }) => (
          <>
            {label && <label className="block text-sm mb-2">{label}<span className="text-error-500">*</span></label>}
            <input {...field} className={`border text-sm text-default-800 border-solid border-light-170 focus:bg-light-100 px-2 py-1 w-full ${height ?? "h-8"} outline-none shadow-none`} />
          </>
        )}
      />
      {errors[name] ? <span className="text-sm text-red-500 absolute right-0 top-[100%]">{errors[name]?.message as string}</span> : null}
    </div>
  )
}